/**
 * @tabler/icons-react v2.44.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconAppsOff = createReactComponent("apps-off", "IconAppsOff", [
  [
    "path",
    {
      d: "M8 4h1a1 1 0 0 1 1 1v1m-.29 3.704a1 1 0 0 1 -.71 .296h-4a1 1 0 0 1 -1 -1v-4c0 -.276 .111 -.525 .292 -.706",
      key: "svg-0"
    }
  ],
  [
    "path",
    {
      d: "M18 14h1a1 1 0 0 1 1 1v1m-.29 3.704a1 1 0 0 1 -.71 .296h-4a1 1 0 0 1 -1 -1v-4c0 -.276 .111 -.525 .292 -.706",
      key: "svg-1"
    }
  ],
  [
    "path",
    {
      d: "M4 14m0 1a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v4a1 1 0 0 1 -1 1h-4a1 1 0 0 1 -1 -1z",
      key: "svg-2"
    }
  ],
  ["path", { d: "M14 7h6", key: "svg-3" }],
  ["path", { d: "M17 4v6", key: "svg-4" }],
  ["path", { d: "M3 3l18 18", key: "svg-5" }]
]);

export { IconAppsOff as default };
//# sourceMappingURL=IconAppsOff.js.map
